// extracted by mini-css-extract-plugin
export default {"headerText":"Breadcrumb_headerText__lSyIb"};